import { css } from '@emotion/react';
import { isFunction } from 'lodash-es';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';
import { useCompactTableContext } from '../../../context/compact-table-context';
import { CompactTableData } from '../types';

export const CompactTableBulkActions = () => {
  const { bulkActions, selectedRows, isSelectable } = useCompactTableContext();

  if (selectedRows.length === 0 || !isSelectable) return null;

  const visibleBulkActions =
    bulkActions?.filter(({ hide = false }) => !(isFunction(hide) ? hide(selectedRows) : hide)) || [];
  if (visibleBulkActions.length === 0) return null;

  return (
    <div css={styles.actionButtonContainer}>
      {visibleBulkActions.map(({ Icon, label, onClick }) => {
        return (
          <Button
            key={label}
            variant='secondary'
            color={theme.font.colors.default}
            onClick={() => onClick?.(undefined, selectedRows as CompactTableData[])}
            label={label}
            size='small'
            css={styles.actionButton}
          >
            {Icon ? <Icon /> : label}
          </Button>
        );
      })}
    </div>
  );
};

const styles = {
  actionButtonContainer: css`
    gap: ${theme.spacing(1)};
  `,
  actionButton: css`
    border: none;
  `,
};
